import Plyr from "plyr";
import {gsap} from "gsap";
// import {GSDevTools} from "gsap/GSDevTools";
//
// gsap.registerPlugin(GSDevTools)
export default class Introduction{
    
    constructor(element) {
        this._wrapper = element;
        this._video = this._wrapper.querySelector('.js-introduction-video');
        this._right = this._wrapper.querySelector('.js-introduction-right');
        this._shape = this._wrapper.querySelector('.js-introduction-shape');
        this._line = this._wrapper.querySelector('.js-introduction-line');
        
        this.init();
        
        if(window.initAnims){
            this.initAnims();
        }
    }
    
    init(){
        this.player = new Plyr(this._video);
    }
    
    initAnims(){
        this.timeline = gsap.timeline();
        this.timeline.from(this._right, {x:-100, alpha:0, ease:"power2.out", duration:1, delay:1});
        this.timeline.from(this._video, {alpha:0, duration:1}, 'second');
        this.timeline.from(this._shape, {alpha:0, scale:0.2, ease:"power2.out", duration:0.6}, 'second+=0.2');
        this.timeline.from(this._line, {alpha:0, x:-25, ease:"power2.out", duration:0.6}, 'second+=0.2');

        // GSDevTools.create({animation: this.timeline});
    }
}